{
  "OH_SALESTYPE": "Salestype",
  "PRODUCTS_NOT_IN_CAMPAIGN": "Products not in campaign",
  "ORDER_AMOUNT_BELOW_FRIEGHT_FREE_LIMIT": "Add items for another",
  "ORDER_AMOUNT_BELOW_FREIGHT_FREE_LIMIT_2": " to receive free freight",
  "NOT_VALID_EMAIL": "Not valid email",
  "NAV_SALE_ASSORTMENT": "NAV_SALE_ASSORTMENT",
  "PRODUCT_EXPORT_NAV_BAR": "Product export",
  "PARCEL_TYPE": "Parcel type",
  "UNIFAUN_ARTICLE_TYPE": "Article type",
  "UNIFAUN_PICKUP_DATE": "Pickup date",
  "UNIFAUN_RETURN_INSTRUCTIONS_HELPER_TEXT": "ADD INFORMATION FOR PICKUP FROM SENDER AND ADDITIONAL INFO",
  "UNIFAUN_RETURN_ROWS_HELPER_TEXT": "REGISTER DETAILED INFORMATION ABOUT PARCEL PER PACKAGING ROW",
  "ADD_PACKAGING_ROW": "Add packaging row",
  "PICKUP_INSTRUCTIONS": "Pickup instructions",
  "DELIVERY_INSTRUCTIONS": "Delivery instructions",
  "AMOUNT_RECIVED_WHEN_APPROVED": "Amount to be received upon approved return",
  "RETURN_INFORMATION": "Return information",
  "RETURN_SERVICE_TYPE": "Service type",
  "RETURN_LOCATION": "Location",
  "RETURN_SENDER": "Sender",
  "RETURN_PICKUP_ADDRESS": "Pickup Address",
  "RETURN_VALIDATION_CREATION": "Validation + creation",
  "SHIPMENT_PRINTS": "Shipment prints:",
  "CREATING_RETURN_HEADER": "Return creation",
  "CREATING_RETURN_INFO": "A return is being created. Please wait...",
  "ERROR_CREATING_RETURN": "An error was returned. Please adjust the input and try again.",
  "SUCCESFULLY_CREATED_RETURN": "The return was successfully created. Submit the order.",
  "DOWNLOAD_SHIPMENT_PDF": "Download shipment PDF",
  "RETURNED_AMOUNT": "Returned amount",
  "CONSUMER_PACKAGE_LENGTH": "Consumer packaging, depth",
  "CONSUMER_PACKAGE_WIDTH": "Consumer packaging, width",
  "CONSUMER_PACKAGE_HEIGHT": "Consumer packaging, height",
  "CONSUMER_PACKAGE_WEIGHT": "Consumer packaging, weight",
  "CONSUMER_PACKAGE_MATERIAL": "Consumer packaging, material",
  "DESIRED_PICKUP_DATE": "Desired pickup date",
  "PARCEL": "Parcel",
  "SUBMIT_RETURN_ORDER": "Submit return order",
  "PICKUP_ADDRESS": "Pickup address",
  "CURRENT_CUSTOMER": "Current customer",
  "CLEARANCE_ARTICLES": "Clearance articles",
  "RETUR_NOPRICE": "User without prices",
  "CLICK_SHIPMENT_PRINT":"Click on the shipment id to print your label.",
  "ALRIK_HEDLUND_CUSTOM_FIELDS": "Alrik Headlund custom fields",
  "HIDE_INVOICES_CHECKBOX": "Hide invoices tab",
  "OPENED_ACTIVITIES": "Opened activities",
  "EXPIRED_ACTIVITIES": "Expired activities",
  "ALL_ACTIVITIES": "All activities",
  "ACTIVITY_TIME": "Activity start",
  "ARTICLE_CATEGORY": "Article category",
  "MEETING_TYPE": "Meeting type",
  "SPOKEN_IN_STORE": "Have you spoken to someone in the store?",
  "ACTIVITY_END_TIME": "Activity end",
  "SALES_CODE_IN_ERP": "Salescode in ERP",
  "MEETIGN_AMOUNT": "Meeting Amount",
  "TOTAL_LAST_MONTH": "Total last Month",
  "TOTAL_THIS_MONTH": "Total this Month",
  "COMPLETED_THIS_MONTH": "Completed this month",
  "COMPLETED_LAST_MONTH": "Completed last month",
  "MEETINGS_TARGET": "Progress this month",
  "MEETINGS_LAST_MONTH_TARGET": "Progress last month",
  "CONVERTED_IN_ORDER_THIS_MONTH": "Actual month meetings generated order",
  "CONVERTED_IN_ORDER_LAST_MONTH": "Prev month meetings generated order",
  "EXPORT_PRODUCT_STOCK_HEDLUND": "Product Stock Hedlund Group",
  "EXPORT_PRODUCT_STOCK_CULT": "Product Stock Cult",
  "RETURN_VALID": "Return valid",
  "MINIMUM_ORDER_VALUE": "Please note that 1000 SEK is the minimum order value."
}
